import { Injectable, inject } from "@angular/core";
import { MessageService } from "primeng/api";

@Injectable({
  providedIn: "root",
})
export class ToastService {
  private messageService = inject(MessageService);

  success(detail: string, summary: string = "Success", life: number = 5000) {
    this.messageService.add({
      severity: "success",
      summary,
      detail,
      life,
      closable: true,
    });
  }

  info(detail: string, summary: string = "Information", life: number = 5000) {
    this.messageService.add({
      severity: "info",
      summary,
      detail,
      life,
      closable: true,
    });
  }

  warning(detail: string, summary: string = "Warning", life: number = 5000) {
    this.messageService.add({
      severity: "warn",
      summary,
      detail,
      life,
      closable: true,
    });
  }

  error(detail: string, summary: string = "Error", life: number = 7000) {
    this.messageService.add({
      severity: "error",
      summary,
      detail,
      life,
      closable: true,
    });
  }

  clear() {
    this.messageService.clear();
  }
}
